// extracted by mini-css-extract-plugin
export var searchBarContainer = "StickySearchContainer-module--search-bar-container--9c0b6";
export var searchBarWrapperSitcky = "StickySearchContainer-module--search-bar-wrapper-sitcky--be3d6";
export var searchBarWrapperSitckyActive = "StickySearchContainer-module--search-bar-wrapper-sitcky-active--ab9a7";